"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAlunoTipoSituacao = exports.EAlunoTipoEscolaOrigem = exports.EAlunoTipoNacionalidade = exports.EAlunoZonaResidencia = exports.EAlunoTipoResp = void 0;
var EAlunoTipoResp;
(function (EAlunoTipoResp) {
    EAlunoTipoResp["Pai"] = "1";
    EAlunoTipoResp["Mae"] = "2";
    EAlunoTipoResp["Aluno"] = "4";
    EAlunoTipoResp["Outro"] = "3";
})(EAlunoTipoResp = exports.EAlunoTipoResp || (exports.EAlunoTipoResp = {}));
var EAlunoZonaResidencia;
(function (EAlunoZonaResidencia) {
    EAlunoZonaResidencia["Urbana"] = "1";
    EAlunoZonaResidencia["Rural"] = "2";
})(EAlunoZonaResidencia = exports.EAlunoZonaResidencia || (exports.EAlunoZonaResidencia = {}));
var EAlunoTipoNacionalidade;
(function (EAlunoTipoNacionalidade) {
    EAlunoTipoNacionalidade["Brasileira"] = "1";
    EAlunoTipoNacionalidade["Naturalizado"] = "2";
    EAlunoTipoNacionalidade["Estrangeira"] = "3";
})(EAlunoTipoNacionalidade = exports.EAlunoTipoNacionalidade || (exports.EAlunoTipoNacionalidade = {}));
var EAlunoTipoEscolaOrigem;
(function (EAlunoTipoEscolaOrigem) {
    EAlunoTipoEscolaOrigem["Publica"] = "PU";
    EAlunoTipoEscolaOrigem["Particular"] = "PA";
})(EAlunoTipoEscolaOrigem = exports.EAlunoTipoEscolaOrigem || (exports.EAlunoTipoEscolaOrigem = {}));
var EAlunoTipoSituacao;
(function (EAlunoTipoSituacao) {
    EAlunoTipoSituacao["Novato"] = "N";
    EAlunoTipoSituacao["Veterano"] = "V";
    EAlunoTipoSituacao["Repetente"] = "R";
    EAlunoTipoSituacao["RepetenteMais1deVez"] = "B";
})(EAlunoTipoSituacao = exports.EAlunoTipoSituacao || (exports.EAlunoTipoSituacao = {}));
